import $ from "jquery";
import CONSTANT from "../../common/js/_constant";
import videoComponent from "../video/videoComponent";

const Testimonial = {
    variables: {
        testimonialContainer: ".testimonials--container",
        flexContainer: ".flex-container",
        testimonialFlexItem: ".flex-item",
        expandedClass: "expanded",
        overlayContainer: ".overlay-container",
        colors: ["#EB707A", "#70D1F6", "#FFDD78"],
        testimonialVideos: ".testimonial-videos",
        testimonialButtons: ".navigation__buttons",
        videoCard: ".video-card",
    },
    methods: {
        adjustWidthofCardInMobile(centerIndex) {
            const { testimonialFlexItem } = Testimonial.variables;
            const $items = $(testimonialFlexItem);

            $items.each((index, element) => {
                const distanceFromCenter = Math.abs(index - centerIndex);
                const widthPercentage = 100 - distanceFromCenter * 10;
                $(element).css("width", `${widthPercentage}%`);
            });
        },
        setCenterItem(index) {
            const { testimonialFlexItem, expandedClass } = Testimonial.variables;
            const $items = $(testimonialFlexItem);

            $items.removeClass(expandedClass).eq(index).addClass(expandedClass);
            Testimonial.methods.adjustWidthofCardInMobile(index);
        },
        addOverlayBackground() {
            const { overlayContainer, colors } = Testimonial.variables;
            $(overlayContainer).each((index, element) => {
                $(element).css({
                    background: `${colors[index % colors.length]}`,
                    "mix-blend-mode": "multiply",
                });
            });
        },
        testimonialVideosInit() {
            const { testimonialVideos, testimonialFlexItem } = Testimonial.variables;
            let players;
            
            players = videoComponent.methods.registerVideo(testimonialVideos);
            if (window.matchMedia(`(max-width:${CONSTANT.breakpoints.md}px)`).matches) {
                $(testimonialFlexItem).on("mouseenter", function () {
                    const index = $(this).index();
                    players.forEach((player, playerIndex) => {
                        player.on("play", () => {
                            const textContent = $(this).find(".flex-item--text");
                            textContent[0].style.opacity = 0;
                            textContent[0].style.visibility = "hidden";
                            textContent[0].style.setProperty('display', 'none', 'important');

                        });
                    });
                });
            }

            $(testimonialFlexItem).on("mouseleave", () => {
                players.forEach((player) => player.pause());
                // show the ".flex-item--text" for all the videos
                $(".flex-item--text").each(function () {
                    this.style.opacity = 1;
                    this.style.visibility = "visible";
                    this.style.setProperty('display', 'flex', 'important');
                });
            });
        },
        init() {
            const { testimonialFlexItem, testimonialContainer, flexContainer } =
                Testimonial.variables;
            const $items = $(testimonialFlexItem);
            const $flexContainer = $(flexContainer);
            const mq = window.matchMedia(`(max-width:${CONSTANT.breakpoints.md}px)`);

            if (!$(testimonialContainer).length) {
                return;
            }

            Testimonial.methods.testimonialVideosInit();

            if (mq.matches) {
                Testimonial.methods.addOverlayBackground();
                const centerIndex = Math.floor($items.length / 2);
                Testimonial.methods.adjustWidthofCardInMobile(centerIndex);

                $flexContainer
                    .on("mouseenter", testimonialFlexItem, function () {
                        Testimonial.methods.setCenterItem($(this).index());
                    })
                    .on("mouseleave", () => {
                        Testimonial.methods.setCenterItem(centerIndex);
                    });
            }
        },
    },
};

$(document).ready(() => {
    Testimonial.methods.init();
});
